import React from 'react';
import { PageHero } from '../components/PageHero';
import { Evidence as EvidenceSection } from '../components/Evidence';
import { Missions } from '../components/Missions';
import { Safety } from '../components/Safety';
import { SectionStage } from '../components/SectionStage';
export function Evidence() {
  return <>
      <PageHero eyebrow="Evidence" title="Proof your team," titleMuted="customers, and auditors trust." description="Every validated path becomes evidence — shareable, exportable, and audit-ready. From technical detail to executive summary in one place." bg="none" data-id="element-1477" />
      <SectionStage fx="squares" data-id="element-1478">
        <EvidenceSection data-id="element-1479" />
      </SectionStage>
      <SectionStage fx="orbit" data-id="element-1480">
        <Missions data-id="element-1481" />
      </SectionStage>
      <SectionStage fx="constellation" data-id="element-1482">
        <Safety data-id="element-1483" />
      </SectionStage>
    </>;
}